import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useNewsPostsQuery } from '../generated/graphql'
import { formatDate } from '../utils/format-date'

const Outer = styled.div`
  display: flex;
  flex-direction: column;
`

const More = styled(Link)`
  display: block;
  align-self: center;
  margin-top: 3rem;
  text-decoration: underline;
`

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

type CompactNewsListProps = {

}
export const CompactNewsList: FunctionComponent<CompactNewsListProps> = () => {
  const newsPostsQuery = useNewsPostsQuery({variables: {first: 5}})
  return <Outer>
    <ItemContainer>
      {
        newsPostsQuery.data?.newsPosts?.nodes?.map(news => {
          if(!news) return null
          return <Item
            key={news.news_postId}
            id={news.news_postId}
            date={new Date(news.date ?? NaN)}
            title={news.title ?? ''}
            link={news.news_fields?.link ?? undefined}
          />
        })
      }
    </ItemContainer>
    <More to="/news">一覧を見る</More>
  </Outer>
}

const ItemOuter = styled.a`
  display: flex;
  gap: 4rem;
  font-weight: 500;
  font-size: 0.9rem;
  @media (max-width: 40rem){
    gap: 0.5rem; 
    flex-direction: column;
  }
  &:hover {
    text-decoration: underline;
  }
`
const ItemDate = styled.div`
`
const ItemContents = styled.div`
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  @media (max-width: 40rem){
    flex: 0 0 auto;
  }
`

const ItemContentsInner = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

type ItemProps = {
  id: number,
  date: Date,
  title: string,
  link?: string
}
const Item: FunctionComponent<ItemProps> = ({id, date, title, link}) => {
  return <ItemOuter href={link}>
    <ItemDate>
      {formatDate(date)}
    </ItemDate>
    <ItemContents>
      <ItemContentsInner>
        {title}
      </ItemContentsInner>
    </ItemContents>
  </ItemOuter>
}
